import React, { useRef } from 'react'
import '../assets/css/contact.css'
import emailjs from '@emailjs/browser';
import Notify from 'simple-notify'

const Contact = () => {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_7kn8wbi",
        "template_y1xsj8g",
        form.current,
        "A_6hC5A95gwpC9g06"
      )
      .then(
        (result) => {
          new Notify ({
            status: 'success',
            title: 'Notification',
            text: 'Votre message a bien été envoyé !',
            effect: 'fade',
            speed: 300,
            customClass: '',
            customIcon: '',
            showIcon: true,
            showCloseButton: true,
            autoclose: false,
            autotimeout: 3000,
            gap: 20,
            distance: 20,
            type: 1,
            position: 'right top'
          })
          console.log(result);
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
  };
  return (
    <>
      <div className="reachme-container" id='contact'>
        <div className="reachme-title2">
          <h2>Vous aimeriez me joindre</h2>

          <h3>Contactez-moi</h3>
        </div>
        <div className="row">
          <div className="col-md-5">
            <div className="reachme-title">
              <div className="row">
                {/*Telephone*/}
                <div className="contact-info  " >
                  <div className="contact-details">
                    <i class="fa-solid fa-phone"></i>
                    <div className="contact-mi">
                      <h4 className="icon-name">Téléphone:</h4>
                      <p className="d-name">+229 67 66 09 96</p>
                    </div>
                  </div>
                </div>
                {/*Email*/}
                <div className="contact-info  " >
                  <div className="contact-details">
                    <i class="fa-solid fa-envelope"></i>
                    <div className="contact-mi">
                      <h4 className="icon-name">Email:</h4>
                      <p className="d-name">setonde.hounnouvi@epitech.eu</p>
                    </div>
                  </div>
                </div>
                {/*Localisation*/}
                <div className="contact-info  " >
                  <div className="contact-details">
                    <i class="fa-solid fa-location-dot"></i>
                    <div className="contact-mi">
                      <h4 className="icon-name">Adresse:</h4>
                      <p className="d-name">St Michel, Cotonou (BENIN)</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 email-me container">
            <form
              action=""
              className="contact-form"
              ref={form}
              onSubmit={sendEmail}
            >
              <div className="row">
                <div className="col-md-12 mb-3 hire-me-title"></div>
                <div className="col-md-6 ">
                  <input
                    type="text"
                    name="user_name"
                    id=""
                    placeholder="Nom"
                  />
                </div>
                <div className="col-md-6 ">
                  <input
                    type="email"
                    name="user_email"
                    id=""
                    placeholder="Email"
                  />
                </div>
                <div className="col-md-12">
                  <input
                    type="text"
                    name="subject"
                    id=""
                    placeholder="Sujet"
                  />
                </div>
                <div className="col-md-12 mb-2">
                  <textarea
                    name="message"
                    id=""
                    cols="60"
                    rows="8"
                    placeholder="Votre Message"
                  ></textarea>
                  <button className="hire-btn" type="submit">
                    Envoyer
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}

export default Contact